import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The per-canvas services every top-level `<Canvas>` mounts once: shared texture release, the
 * frame profile and the software renderer probe.
 */
import { SharedTextureRelease } from './sharedTexture.js';
import { FrameProfiler } from './frameProfile/FrameProfiler.js';
import { SoftwareRenderingProbe } from './softwareRendering/SoftwareRenderingProbe.js';
export function CanvasServices() {
    return (_jsxs(_Fragment, { children: [_jsx(SharedTextureRelease, {}), _jsx(FrameProfiler, {}), _jsx(SoftwareRenderingProbe, {})] }));
}
//# sourceMappingURL=CanvasServices.js.map